import LeadsList from "../views/LeadsList"

export default [
	{
		path: "/:tenantId/leads",
		component: LeadsList,
		meta: { featureId: "leads" },
		props: true
	}
]
